import React from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  FormHelperText,
} from '@material-ui/core'
import {DatePicker} from '@material-ui/pickers'
import moment from 'moment'
export default function WDateField({data, onChange, tabActive}) {
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <DatePicker
        label={data.name}
        inputVariant="outlined"
        value={data.value}
        onChange={e => {
          onChange(
            e,
            data.key,
            moment(e)
              .local()
              .format()
          )
        }}
      />
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </FormControl>
  )
}
